// extracted by mini-css-extract-plugin
module.exports = {"Registration":"index-module_Registration_1sf5n"};